<ng-container [ngSwitch]="easControl.field.widget.type">
    <ng-container *ngSwitchCase="'heading'">
        <h3>{{ easControl.field.title }}</h3>
    </ng-container>
    <ng-container *ngSwitchCase="'paragraph'">
        <p [innerHtml]="easControl.field.options.content"></p>
    </ng-container>
    <ng-container *ngSwitchCase="'string'">
        <mat-form-field appearance="outline">
            <mat-label *ngIf="easControl.field.widget.showInlineLabel">{{ easControl.field.title }}</mat-label>
            <input matInput [placeholder]="easControl.field.widget.placeholder"  type="text" [formControl]="easControl.control">
            <mat-error *ngIf="this.easControl.control.errors">{{currentErrors}}</mat-error>
        </mat-form-field>
    </ng-container>
    <ng-container *ngSwitchCase="'number'">
        <mat-form-field appearance="outline">
            <mat-label *ngIf="easControl.field.widget.showInlineLabel">{{ easControl.field.title }}</mat-label>
            <input matInput [placeholder]="easControl.field.widget.placeholder" type="number" [formControl]="easControl.control">
            <mat-error *ngIf="this.easControl.control.errors">{{currentErrors}}</mat-error>
        </mat-form-field>
    </ng-container>
    <ng-container *ngSwitchCase="'email'">
        <mat-form-field appearance="outline">
            <mat-label *ngIf="easControl.field.widget.showInlineLabel">{{ easControl.field.title }}</mat-label>
            <input matInput  [placeholder]="easControl.field.widget.placeholder"  type="email" [formControl]="easControl.control">
            <mat-error *ngIf="this.easControl.control.errors">{{currentErrors}}</mat-error>
        </mat-form-field>
    </ng-container>
    <ng-container *ngSwitchCase="'search'">
        <mat-form-field appearance="outline">
            <mat-label *ngIf="easControl.field.widget.showInlineLabel">{{ easControl.field.title }}</mat-label>
            <input matInput  [placeholder]="easControl.field.widget.placeholder"  type="search" [formControl]="easControl.control">
            <mat-error *ngIf="this.easControl.control.errors">{{currentErrors}}</mat-error>
          <button *ngIf="easControl.control.value" matSuffix mat-icon-button aria-label="Clear search" type="button"
              (click)="clearSearch()">
                <mat-icon>close</mat-icon>
            </button>
        </mat-form-field>
    </ng-container>
    <ng-container *ngSwitchCase="'password'">
        <eas-easform-control-password [errors]="currentErrors" [easControl]="easControl"></eas-easform-control-password>
    </ng-container>
    <ng-container *ngSwitchCase="'text'">
        <mat-form-field appearance="outline">
            <mat-label *ngIf="easControl.field.widget.showInlineLabel">{{ easControl.field.title }}</mat-label>
            <textarea matInput  [placeholder]="easControl.field.widget.placeholder" [formControl]="easControl.control"></textarea>
            <mat-error *ngIf="this.easControl.control.errors">{{currentErrors}}</mat-error>
        </mat-form-field>
    </ng-container>
    <ng-container *ngSwitchCase="'wysiwyg'">
        <quill-editor class="block" [formControl]="easControl.control" [placeholder]="easControl.field.widget.placeholder"></quill-editor>
        <mat-error *ngIf="this.easControl.control.errors">{{currentErrors}}</mat-error>
    </ng-container>
    <ng-container *ngSwitchCase="'csvInput'">
        <app-csv-input [formControl]="easControl.control" [easControl]="easControl"></app-csv-input>
        <mat-error *ngIf="this.easControl.control.errors">{{currentErrors}}</mat-error>
    </ng-container>
    <ng-container *ngSwitchCase="'simpleSelect'">
        <mat-form-field appearance="outline">
            <mat-label *ngIf="easControl.field.widget.showInlineLabel">{{ easControl.field.title }}</mat-label>
            <mat-select [formControl]="easControl.control"
                        [placeholder]="easControl.field.widget.placeholder"
                        (openedChange)="updateOptions($event)"
            >
                <mat-option>
                    <ngx-mat-select-search
                         [formControl]="searchCtrl"
                         placeholderLabel="Search..."
                         i18n-placeholderLabel
                         noEntriesFoundLabel="No item found"
                         i18n-noEntriesFoundLabel
                      ></ngx-mat-select-search>
                </mat-option>
                <mat-option *ngFor="let option of filteredOptions$ | async" [value]="option[easControl.field.options?.key ?? 'id']" [title]="option.name" [disabled]="option.disabled">{{ option.name }}</mat-option>
            </mat-select>
          <mat-error *ngIf="this.easControl.control.errors">{{currentErrors}}</mat-error>
        </mat-form-field>
    </ng-container>
    <eas-easform-control-select *ngSwitchCase="'select'" [errors]="errors"
        [easControl]="easControl">
    </eas-easform-control-select>
    <eas-easform-control-multiselect *ngSwitchCase="'sourceMultiSelect'"
        [easControl]="easControl" [errors]="currentErrors">
    </eas-easform-control-multiselect>
    <ng-container *ngSwitchCase="'multiSelect'">
        <mat-form-field appearance="outline">
          <mat-label *ngIf="easControl.field.widget.showInlineLabel">{{ easControl.field.title }}</mat-label>
          <mat-select multiple [formControl]="easControl.control"
                      [placeholder]="easControl.field.widget.placeholder" #multiSelect>
              <mat-option>
                  <ngx-mat-select-search
                       [formControl]="searchCtrl"
                       placeholderLabel="Search..."
                       i18n-placeholderLabel
                       noEntriesFoundLabel="No item found"
                       i18n-noEntriesFoundLabel
                    ></ngx-mat-select-search>
              </mat-option>
              <mat-option *ngFor="let option of filteredOptions$ | async" [value]="option[easControl.field.options?.key ?? 'id']" [title]="option.name">{{ option.name }}</mat-option>
          </mat-select>
          <mat-error *ngIf="this.easControl.control.errors">{{currentErrors}}</mat-error>
        </mat-form-field>
    </ng-container>
    <ng-container *ngSwitchCase="'selectableList'">
        <eas-selectable-list [formControl]="easControl.control" [title]="easControl.field.title"
        [items]="categories$ | async"></eas-selectable-list>
        <mat-error *ngIf="this.easControl.control.errors">{{currentErrors}}</mat-error>
    </ng-container>
    <ng-container *ngSwitchCase="'treeEditorFormControl'">
        <eas-tree-editor-form-control [formControl]="easControl.control"
                                      [options]="easControl.field.options.options"
        >
        </eas-tree-editor-form-control>
    </ng-container>
    <ng-container *ngSwitchCase="'treeSelectorFormControl'">
        <eas-tree-selector-form-control [formControl]="easControl.control"
                                      [nodes]="easControl.field.options.categories"
                                      [options]="easControl.field.options.options">
        </eas-tree-selector-form-control>
    </ng-container>
    <ng-container *ngSwitchCase="'formBuilder'">
        <eas-builder-form [formControl]="easControl.control"></eas-builder-form>
    </ng-container>
    <ng-container *ngSwitchCase="'gmc'">
        <eas-gmc-form-control [formControl]="easControl.control"></eas-gmc-form-control>
    </ng-container>
    <ng-container *ngSwitchCase="'likert'">
        <mat-form-field appearance="outline">
            <mat-label *ngIf="easControl.field.widget.showInlineLabel">{{ easControl.field.title }}</mat-label>
            <mat-select [formControl]="easControl.control">
                <mat-option *ngFor="let option of categories$ | async" [value]="option.id">{{ option.name }}</mat-option>
            </mat-select>
          <mat-error *ngIf="this.easControl.control.errors">{{currentErrors}}</mat-error>
        </mat-form-field>
    </ng-container>
    <ng-container *ngSwitchCase="'date'">
        <mat-form-field appearance="outline">
            <mat-label *ngIf="easControl.field.widget.showInlineLabel">{{ easControl.field.title }}</mat-label>
            <mat-datepicker-toggle matSuffix [for]="myDatepicker"></mat-datepicker-toggle>
            <mat-datepicker #myDatepicker></mat-datepicker>
            <input matInput [matDatepicker]="myDatepicker" [formControl]="easControl.control">
            <mat-error *ngIf="this.easControl.control.errors">{{currentErrors}}</mat-error>
        </mat-form-field>
    </ng-container>
    <ng-container *ngSwitchCase="'datetime'">
        <mat-form-field>
            <mat-label *ngIf="easControl.field.widget.showInlineLabel">{{ easControl.field.title }}</mat-label>
            <mat-datetimepicker-toggle [for]="datetimePicker" matSuffix></mat-datetimepicker-toggle>
            <mat-datetimepicker #datetimePicker type="datetime" openOnFocus="true" timeInterval="5"></mat-datetimepicker>
            <input matInput [formControl]="easControl.control" [matDatetimepicker]="datetimePicker" autocomplete="false">
          <mat-error *ngIf="this.easControl.control.errors">{{currentErrors}}</mat-error>
        </mat-form-field>
    </ng-container>
    <ng-container *ngSwitchCase="'boolean'">
      <div>
        <mat-checkbox [formControl]="easControl.control">{{ easControl.field.title }}</mat-checkbox>
        <mat-error *ngIf="this.easControl.control.errors && (easControl.control.touched || easControl.control.dirty)">{{currentErrors}}</mat-error>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'file'">
      <div>
        <eas-file-upload-control [formControl]="easControl.control"></eas-file-upload-control>
        <mat-error *ngIf="this.easControl.control.errors && (easControl.control.touched || easControl.control.dirty)">{{currentErrors}}</mat-error>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'hidden'">
    </ng-container>
    <ng-container *ngSwitchDefault i18n>
        Unkown type {{ easControl.field.widget.type }}
    </ng-container>
</ng-container>
